<template>
    <v-container>
        <v-row>
            <v-col sm="6">
                <v-img
                    :src="footerLogo"
                    width="443"
                ></v-img>
            </v-col>
            <v-col sm="6">
                <b>Email:</b><br/>
                <a href="mailto:info@polyphonyproject.com">info@polyphonyproject.com</a><br/>
                <br/>
                <b>Facebook:</b><br/>
                <a href="https://facebook.com/polyphonyproject" target="_blank">facebook.com/polyphonyproject</a><br/>
                <br/>
                <b>Youtube:</b><br/>
                <a href="https://www.youtube.com/polyphonyprojectcom" target="_blank">youtube.com/polyphonyprojectcom</a><br/>
                <br/>
                <b>Instagram:</b><br/>
                <a href="https://instagram.com/polyphony.project" target="_blank">instagram.com/polyphony.project</a>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="6">
                {{ new Date().getFullYear() }} — <strong>{{ $t('app.title') }}</strong>
            </v-col>
            <v-col sm="6">
                <v-img
                    src="/img/footer_eu_logo.jpg"
                    width="390"
                ></v-img>
            </v-col>
        </v-row>  
    </v-container>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    computed: {
      footerLogo () {
        return '/img/footer-logo-' + this.$i18n.locale + '.png'
      }
    },
    name: 'FooterContent',
  }
</script>
